import { migrateLinkedDatasetIds } from "@/store/migrations/migrateLinkedDatasetIds";
import { tabStorage } from "@/store/tabStore/storage";

import { MIGRATION_KEYS } from "./constant";

// Removes each migration key from the storage after the end of the migration.
const ALL_MIGRATION_KEYS = Object.values(MIGRATION_KEYS);
const cleanUpLocalForage = async () => {
  await Promise.all(
    ALL_MIGRATION_KEYS.map((key) => tabStorage.removeItem(key))
  );
};

// The onBeforeLift prop of PersistGate calls this function. Thus the migration
// is complete before the app renders.
export const handleBeforeLift = async () => {
  try {
    await migrateLinkedDatasetIds();
  } catch (e) {
    console.error("[onBeforeLift] Migration failed:", e);
  } finally {
    await cleanUpLocalForage();
  }
};
